var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeleconsultationCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19369_55502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19369_55502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33073 16.6668C2.8724 16.6668 2.48003 16.5036 2.15365 16.1772C1.82726 15.8509 1.66406 15.4585 1.66406 15.0002V5.00016C1.66406 4.54183 1.82726 4.14947 2.15365 3.82308C2.48003 3.49669 2.8724 3.3335 3.33073 3.3335H13.3307C13.7891 3.3335 14.1814 3.49669 14.5078 3.82308C14.8342 4.14947 14.9974 4.54183 14.9974 5.00016V8.75016L18.3307 5.41683V14.5835L14.9974 11.2502V15.0002C14.9974 15.4585 14.8342 15.8509 14.5078 16.1772C14.1814 16.5036 13.7891 16.6668 13.3307 16.6668H3.33073ZM3.33073 15.0002H13.3307V5.00016H3.33073V15.0002Z",
    fill: "#475467"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleconsultationCamera);
export default __webpack_public_path__ + "static/media/teleconsultation_camera.394f699414f03cd7d41078935eb4ed20.svg";
export { ForwardRef as ReactComponent };